module.exports = __webpack_public_path__ + "img/flag_Indonesia.3cfb87d6.png";